import React from 'react';
import { cn } from '@/lib/utils';

export const SectionHeading = ({ 
  badge, 
  title, 
  subtitle, 
  centered = false,
  light = false,
  className 
}) => {
  return (
    <div className={cn(
      'max-w-3xl',
      centered && 'mx-auto text-center',
      className
    )}>
      {badge && (
        <div className={cn(
          'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium mb-4',
          light 
            ? 'bg-white/10 text-white/80 border border-white/20' 
            : 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800'
        )}>
          {badge}
        </div>
      )}
      <h2 className={cn(
        'text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight',
        light ? 'text-white' : 'text-slate-900 dark:text-white'
      )}>
        {title}
      </h2>
      {subtitle && (
        <p className={cn(
          'mt-4 text-lg md:text-xl',
          light ? 'text-white/70' : 'text-slate-600 dark:text-slate-400'
        )}>
          {subtitle}
        </p>
      )}
    </div>
  );
};
